<template>
  <div :class="{'nav-open': $sidebar.showSidebar}">
    <notifications></notifications>
    <router-view></router-view>
  </div>
</template>

<script>
import nativeToast from 'native-toast'

import {mapGetters} from 'vuex'
export default {
  computed:{
    ...mapGetters(['notifications','authedUser'])
  },
  created(){
    if(localStorage.getItem("authedUser")!=null){
        this.$store.commit("setauthedUser",JSON.parse(localStorage.getItem("authedUser")));
    }
    this.$store.dispatch("fetchUsers")
    this.$store.dispatch("fetchCategories")
    this.$store.dispatch("fetchSubCategories")
    this.$store.dispatch("fetchInventoryItems")
    this.$store.dispatch("fetchQuotes")
    this.$store.dispatch("fetchQuoteItems")
    this.$store.dispatch("fetchAutoIds")
    
  },
  methods:{
  // ...mapActions(['fetchAllServiceProviders'])
  notifyVue(message, type) {
     nativeToast({
          message: message,
          position: 'north-east',
          timeout: 5000,
          type: type
        })
  },
},
watch:{
 notifications(){
   if(this.notifications!=null){
      this.notifyVue(this.notifications.message,this.notifications.type)
   }
 },
 authedUser() {
   console.log("yoho")
   if(this.authedUser!=null){
     if(this.authedUser.isadmin==true){
       this.$router.push({path:'/admin/dashboard'})
     }
     else{
       this.$router.push({path:'/user/items'})

     }
   }
   else{
     console.log("noone")
     this.$router.push({path:'/'})
   }

 }
  },
};
</script>



<style lang="scss">


.wrapper .sidebar .nav .nav-item.active > .nav-link{
  color:white !important;
  background: #0066ff !important;  
}

.wrapper .sidebar .sidebar-wrapper{
background:#5580fe !important;

}
.main-color {
background:#5580fe !important;
}
::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: rgba(0,0,0.0980392,0.5) !important;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: rgba(0,0,0.0980392,0.5)!important;
}

::-ms-input-placeholder { /* Microsoft Edge */
  color: rgba(0,0,0.0980392,0.5) !important;
}

.ant-upload.ant-upload-drag {
    height: 100px !important;
}
th {
  background: #5580fe !important;
  color: #fff !important;
}
.btn-primary {
  // #5580fe
  // #4e73df
  background: #5580fe !important;
  color: #fff !important;
  border: none !important;
}
input, select, textarea {
  background: #fff !important;
  border: 1px solid #ccc !important;
}
.ant-upload.ant-upload-select {
    display: block !important;
}

// .ant-btn:hover {
//   outline: none !important;
//   border-color: #000 !important;
//   color: #000 !important;
// }
// .ant-pagination-item-active {
//   border-color: #000 !important;
//   color: #000 !important;
// }
.ant-select-selection--single {
    height: 42px !important;
}
// .ant-select-focused .ant-select-selection, .ant-select-selection:focus, .ant-select-selection:active {
//     border-color: #000 !important;
//     border-right-width: 1px !important;
//     outline: 0;
//     box-shadow: none !important;
// }
.vue-notifyjs.notifications {
  .alert {
    z-index: 10000;
  }
  .list-move {
    transition: transform 0.3s, opacity 0.4s;
  }
  .list-item {
    display: inline-block;
    margin-right: 10px;
  }
  .list-enter-active {
    transition: transform 0.2s ease-in, opacity 0.4s ease-in;
  }
  .list-leave-active {
    transition: transform 1s ease-out, opacity 0.4s ease-out;
  }

  .list-enter {
    opacity: 0;
    transform: scale(1.1);
  }
  .list-leave-to {
    opacity: 0;
    transform: scale(1.2, 0.7);
  }
}
</style>
